

import { Injectable } from '@angular/core';
import {
    DEFAULT_NEGATIVE_COLOR,
    DEFAULT_NEUTRAL_COLOR,
    DEFAULT_POSITIVE_COLOR
} from '@dat/datiq-components-pkg/utils';
import {
    datiqFormatPercent,
    datiqGetCurrencyStringNoRounding,
    DATIQ_DEFAULT_EMPTY_LABEL
} from '@dat/datiq-core/models';
import { DatiqGraphCardChartLabel, IDatiqGraphCardChart } from '../models';

@Injectable({
    providedIn: 'root',
})
export class DatiqGraphCardChartService {
    private readonly _percentPositiveIcon: string = 'app:arrow-drop-up';
    private readonly _percentNegativeIcon: string = 'app:arrow-drop-down';
    private readonly _percentNeutralIcon: string = '';
    private readonly _positiveColor: string = DEFAULT_POSITIVE_COLOR;
    private readonly _negativeColor: string = DEFAULT_NEGATIVE_COLOR;
    private readonly _neutralColor: string = DEFAULT_NEUTRAL_COLOR;
    private readonly _defaultStrokeWidth: number = 2;

    constructor() {}

    isPositive(settings: IDatiqGraphCardChart): boolean {
        return settings?.current > 0 && settings.useColor;
    }
    isNegative(settings: IDatiqGraphCardChart): boolean {
        return settings?.current < 0 && settings.useColor;
    }
    createPercentLabel(settings: IDatiqGraphCardChart): string {
        return `${datiqFormatPercent(settings?.current)}`;
    }
    getPercentIcon(settings: IDatiqGraphCardChart): string {
        return this.isPositive(settings)
            ? this._percentPositiveIcon
            : this.isNegative(settings)
            ? this._percentNegativeIcon
            : this._percentNeutralIcon;
    }
    getColor(settings: IDatiqGraphCardChart): string {
        return this.isPositive(settings)
            ? this.getPositiveColor(settings)
            : this.isNegative(settings)
            ? this.getNegativeColor(settings)
            : this.getNeutralColor(settings);
    }

    getNeutralColor(settings: IDatiqGraphCardChart): string {
        return !!settings.neutralColor
            ? settings.neutralColor
            : this._neutralColor;
    }

    getNegativeColor(settings: IDatiqGraphCardChart): string {
        return !!settings.negativeColor
            ? settings.negativeColor
            : this._negativeColor;
    }

    getPositiveColor(settings: IDatiqGraphCardChart): string {
        return !!settings.positiveColor
            ? settings.positiveColor
            : this._positiveColor;
    }

    getLabel(settings: IDatiqGraphCardChart): string {
        return this.isPercentLabel(settings)
            ? this.createPercentLabel(settings)
            : this.isDollarLabel(settings)
            ? this.createDollarLabel(settings)
            : DATIQ_DEFAULT_EMPTY_LABEL;
    }

    createDollarLabel(settings: IDatiqGraphCardChart): string {
        return `${datiqGetCurrencyStringNoRounding(settings?.current)}`;
    }

    isPercentLabel(settings: IDatiqGraphCardChart): boolean {
        return settings?.labelType === DatiqGraphCardChartLabel.Percent;
    }

    isDollarLabel(settings: IDatiqGraphCardChart): boolean {
        return settings?.labelType === DatiqGraphCardChartLabel.Dollar;
    }
}
